import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import { datadogRum } from '@datadog/browser-rum';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch((err) => console.error(err));
datadogRum.init({
    applicationId: environment.datadog.applicationId,
    site: environment.datadog.site,
    service: environment.datadog.service,
    env: environment.datadog.env,
    clientToken: environment.datadog.clientToken,
    version: '1.0.0',
    sampleRate: 100,
    replaySampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
});
